import { call, put, takeLatest } from 'redux-saga/effects'
import nautilusApi from '../../nautilusApi'
import {
  setUpgradeState,
  upgradeRequest,
  upgradeResponse,
} from './actions'
import { STATE_REQUESTING } from './constants'

const api = {
  async upgradeSubscription(body) {
    return nautilusApi.fetch('/upgrade', {
      method: 'POST',
      body: JSON.stringify(body)
    })
  }
}

export function * upgradeRequestSaga(action) {
  yield put(setUpgradeState(STATE_REQUESTING))

  try {
    const response = yield call(api.upgradeSubscription, action.payload)
    yield put(upgradeResponse(response))
  } catch (error) {
    yield put(upgradeResponse(error))
  }
}

export default function * saga() {
  yield takeLatest(upgradeRequest, upgradeRequestSaga)
}
